import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate2x.svg'

export const IconPlaybackRate2x = IconSVG as IconComponent
